import {html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {property} from 'lit/decorators/property.js';
import {classMap} from 'lit/directives/class-map.js';
import {live} from 'lit/directives/live.js';
import {
	AttributeType,
	ConfigurationInterpreter,
} from '@viamedici-spc/configurator-ts';

import {SpcBaseAttribute} from './spcBaseAttribute';
import {attributeIdToString} from './util/spcUtils';
import {staggeredReveal} from '../../css/styleSets';
import {attributeWidget} from '../../css/attributeWidget';
import info from '../../../icons/info';
import reset from '../../../icons/reset';
import radio from '../../../icons/radio';
import radioChecked from '../../../icons/radio-checked';

@customElement('spc-numeric-attribute')
export class SpcNumericAttribute extends SpcBaseAttribute {

	static styles = [
		staggeredReveal,
		attributeWidget,
		css`
			:host {
			}
		`];

	@property({type: Number})
	value = null;

	stateChanged(state) {
		super.stateChanged(state);

		if (this.spcConfiguration) {
			//this.attribute = ConfigurationInterpreter.getNumericAttribute(this.spcConfiguration, this.attributeId);
			if (this.attribute) {
				console.log('SpcNumericAttribute stateChanged', this.attribute);
				this.value = this.pendingValue !== null ? this.pendingValue ?? '' : this.attribute.decision?.state ?? '';
			} else {
				console.error('Component attribute not found with id', this.attributeId, this.spcConfiguration);
			}
		}
	}
	async resetDecision() {
		this.session.makeDecision({
			type: AttributeType.Numeric,
			attributeId: this.attribute.id,
			state: null
		});
	}
	async onKeyDown(event) {
		if (event.key === 'Enter') {
			await this.applyValue();
		}
	}
	onChange(event) {
		const target = event.target;
		this.pendingValue = target.value === '' ? undefined : parseFloat(target.value);
	}
	async applyValue() {
		if (this.pendingValue === null) {return;}

		const precision = Math.pow(10, this.attribute.decimalPlaces);
		const round = (value) => Math.round((value + Number.EPSILON) * precision) / precision;
		const roundedValue = this.pendingValue !== undefined ? round(this.pendingValue) : this.pendingValue;

		this.pendingValue = null;

		this.session.makeDecision({
			type: AttributeType.Numeric,
			attributeId: this.attribute.id,
			state: roundedValue
		});
	}
	isSatisfied() {
		return this.attribute?.isSatisfied ?? false;
	}
	render() {
		return html`
			<div class="attribute ${classMap({satisfied: this.isSatisfied()})}">
				<div class="title">
					<div class='icon indicator'>${this.isSatisfied() ? radioChecked : radio}</div>
					<span class="label">
						<trans-label .showIdWhenMissing=${true} key="${this.attribute.key}" context="F" title="${this.attribute.key}"></trans-label>
						(${this.attribute?.range?.min}-${this.attribute?.range?.max})
					</span>
					<div class="tools">
						<button class='tools_button' @click="${this.showInfo}"><span class="icon">${info}</span></button>
						<button class='tools_button' @click="${this.resetDecision}"><span class="icon">${reset}</span></button>
					</div>
				</div>
				<div class="values">
					<input
						class="numericInput"
						type="number"
						step="${Math.pow(0.1, this.attribute.decimalPlaces)}"
						min="${this.attribute.range.min}"
						max="${this.attribute.range.max}"
						.value="${live(this.value)}"
						@change="${this.onChange}"
						@keydown="${this.onKeyDown}"
						@blur="${this.applyValue}"
					</input>
				</div>
			</div>

		`;
	}
}
